"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectorType = void 0;
var ConnectorType;
(function (ConnectorType) {
    ConnectorType["GOOGLE_TAG_MANAGER"] = "google tag manager";
    ConnectorType["FACEBOOK_PIXEL"] = "facebook pixel";
    ConnectorType["WEBHOOK"] = "webhook";
    ConnectorType["GOOGLE_SHEETS"] = "google sheets";
    ConnectorType["GOOGLE_ANALYTICS"] = "google analytics";
})(ConnectorType = exports.ConnectorType || (exports.ConnectorType = {}));
//# sourceMappingURL=connectors.js.map